<div class="mainWrapper">
  <div class="heroWrapper">
    <h1 class="headingWL backdrop">
      Journey Through<span class="ms-2"> Virsa's Culture</span>
    </h1>
  </div>
  <div class="d-flex flex-column align-items-center">
    <div
      class="d-flex flex-row justify-content-between gap-2 flex-wrap my-4 blogWrapper"
    >
      <div
        class="d-flex flex-column blogCard point"
        routerLink="/blog/{{ blog.attributes.slug }}"
        *ngFor="let blog of pageslice"
      >
        <div class="imgWrap">
          <img
            [src]="
              getImage(
                blog.attributes.image.data.attributes.formats.thumbnail.url
              )
            "
            [alt]="blog.attributes.title"
            loading="lazy"
          />
        </div>
        <div class="d-flex flex-column justify-content-between detailWrap">
          <div class="w-100">
            <h2 class="blogHeading">
              {{ blog.attributes.title }}
            </h2>
            <p class="blogSummary">
              {{ blog.attributes.summary }}
            </p>
          </div>
          <div class="d-flex flex-row align-items-center gap-4">
            <img
              loading="lazy"
              class="writerImg"
              src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/writerImg.jpg"
              alt="Writer_Image"
            />
            <div class="d-flex flex-column">
              <div class="writerName">
                {{ blog.attributes.meta?.author }}
              </div>
              <div class="blogDate">
                {{ Date(blog.attributes.publishedAt) }} |
                {{ blog.attributes.category.data.attributes.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <mat-paginator
    [length]="this.blogs.length"
    [pageSize]="9"
    (page)="onPageChange($event)"
  ></mat-paginator>
</div>
